// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"14609a4e","390":"fc66e6e2","427":"f37368ab","460":"44f69694","463":"1d29f908","599":"123ba856","817":"bb08c0e7","982":"dbca1df2"}[chunkId] + ".chunk.js";
};